(()=>{
  function main(){
    let iframe = document.querySelector('#Product__video');
    const player = new Vimeo.Player(iframe);
    let close = document.querySelector('.js-close-video');
    let playButton = document.querySelector('.Product__view-video');
    let mobileWrapper = document.querySelector('.mobile-video-wrapper');
    const gallery = document.querySelector('media-gallery').querySelector('.product-gallery-slider');

    playButton.addEventListener('click', function () {
      iframe.classList.add('shown');
      close.classList.add('shown');
      mobileWrapper.classList.add('shown');
      gallery.style.opacity = 0.25;
      playButton.style.opacity = 0.25;

      player.play();

      player.on('ended', function (data) {
        iframe.classList.remove('shown');
        close.classList.remove('shown');
        mobileWrapper.classList.remove('shown');
        gallery.style.opacity = 1;
        playButton.style.opacity = 1;
      });

    });

    close.addEventListener('click', function () {
      player.pause();
      player.setCurrentTime(0);
      iframe.classList.remove('shown');
      close.classList.remove('shown');
      mobileWrapper.classList.remove('shown');
      gallery.style.opacity = 1;
      playButton.style.opacity = 1;
    });
  }

  setTimeout(() => {
    main();
  }, 1000);
})();
